import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocationPinIcon from './LocationPinIcon';
import AlertIcon from './AlertIcon';
import LeftChevron from './LeftChevron';
import ContactFooter from './ContactFooter';
import formatAddressForDisplay from './formatAddressForDisplay';
import * as availabilityApi from '../availabilityApi';

class ConfirmAddress extends Component {
  determineCoverage = (e) => {
    e.preventDefault();
    this.props.loading();

    availabilityApi
      .determineCoverage(this.props.address.zipCode)
      .then((response) => {
        const { data } = response;
        this.props.loaded();
        this.props.advance(data.result);
      })
      .catch((err) => {
        this.props.loaded();
        console.log(err); // eslint-disable-line no-console
        this.props.advance(false);
      });
  };
  render() {
    let commentText = this.props.requiresConfirmation
      ? 'We found a similar address:'
      : 'We found your address:';

    const cardClass = this.props.wasFound ? 'address-card' : 'address-card warn';

    if (!this.props.wasFound) commentText = "We can't find this address. Use it anyway?";

    const buttonText = this.props.wasFound ? 'Use Address' : 'Use Anyway';

    return (
      <div className="confirm-addr-step">
        {this.props.existingAddress && (
          <div className="description">It appears we already have that address on file:</div>
        )}
        <div className={cardClass}>
          <div className="icon">{this.props.wasFound ? <LocationPinIcon /> : <AlertIcon />}</div>
          <div className="content">
            {!this.props.existingAddress && <div className="comment">{commentText}</div>}
            {formatAddressForDisplay(this.props.address || {})}
          </div>
          <button className="btn btn-primary action desktop-tablet-only" onClick={this.determineCoverage}>
            {buttonText}
          </button>
          <button className="btn btn-primary action use mobile-only" onClick={this.determineCoverage}>
            Use
          </button>
        </div>
        <div className="footer full-width">
          <ContactFooter />
          <div className="go-back">
            <button className="btn button-link" onClick={this.props.goBack}>
              <LeftChevron /> <span className="text">Back to Address</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ConfirmAddress.propTypes = {
  address: PropTypes.shape({
    line1: PropTypes.string,
    line2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
  }).isRequired,
  requiresConfirmation: PropTypes.bool.isRequired,
  existingAddress: PropTypes.bool.isRequired,
  wasFound: PropTypes.bool.isRequired,
  advance: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  loading: PropTypes.func.isRequired,
  loaded: PropTypes.func.isRequired,
};

export default ConfirmAddress;
